/**
 * Redux middleware that auto-tracks CRUD operations as journey events.
 * Intercepts _SUCCESS and _ERROR actions to log crud_operation events.
 */

const ACTION_KEYWORDS = {
  CREATE: "create", ADD: "create", STORE: "create",
  UPDATE: "update", EDIT: "update", PATCH: "update",
  DELETE: "delete", REMOVE: "delete", DESTROY: "delete",
  APPROVE: "approve", REJECT: "reject", PUBLISH: "publish",
  ACTIVATE: "activate", DEACTIVATE: "deactivate",
  SUBMIT: "submit", CANCEL: "cancel", ARCHIVE: "archive",
};

const KEYWORD_REGEX = new RegExp(
  `(?:^|_)(${Object.keys(ACTION_KEYWORDS).join("|")})(?:_|$)`,
  "i"
);

function inferCrudAction(actionType) {
  const match = actionType.match(KEYWORD_REGEX);
  if (!match) return null;
  return ACTION_KEYWORDS[match[1].toUpperCase()] || null;
}

function inferEntityType(actionType) {
  const cleaned = actionType
    .replace(/^\[VERTEX360\]/, "")
    .replace(/_CALL$|_SUCCESS$|_ERROR$|_PENDING$/, "");

  const withoutKeywords = Object.keys(ACTION_KEYWORDS).reduce(
    (str, kw) =>
      str.replace(new RegExp(`(^${kw}_|_${kw}$|_${kw}_)`, "gi"), "_"),
    cleaned
  );

  return withoutKeywords
    .replace(/^_+|_+$/g, "")
    .toLowerCase()
    .replace(/_/g, " ")
    .trim() || null;
}

let JourneyEventBuffer = null;

function getBuffer() {
  if (!JourneyEventBuffer) {
    try {
      JourneyEventBuffer = require("Utils/JourneyEventBuffer").default;
    } catch (e) {
      return null;
    }
  }
  return JourneyEventBuffer;
}

const journeyMiddleware = () => (next) => (action) => {
  const result = next(action);

  if (!action.type || typeof action.type !== "string") return result;

  const isSuccess = action.type.endsWith("_SUCCESS");
  const isError = action.type.endsWith("_ERROR");
  if (!isSuccess && !isError) return result;

  const crudAction = inferCrudAction(action.type);
  if (!crudAction) return result;

  try {
    const buffer = getBuffer();
    if (buffer) {
      buffer.track("crud_operation", {
        event_data: {
          action_type: action.type,
          crud: crudAction,
          entity: inferEntityType(action.type),
          success: isSuccess,
        },
      });
    }
  } catch (e) {
    // Never break the app for tracking
  }

  return result;
};

export default journeyMiddleware;
